import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './admin-client-admins.loaders';
import { clientAdminsKeys } from './admin-client-admins.queries';

export const useAdminCreateClientAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createAdmin, {
    onSuccess: () => {
      return queryClient.invalidateQueries(clientAdminsKeys.all);
    },
  });
};

export const useAdminUpdateClientAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateAdmin, {
    onSuccess: () => {
      return queryClient.invalidateQueries(clientAdminsKeys.all);
    },
  });
};

export const useAdminDeleteClientAdmin = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteAdmin, {
    onSuccess: () => {
      return queryClient.invalidateQueries(clientAdminsKeys.lists);
    },
  });
};

export const useAdminSendInvite = () => {
  return useMutation(loaders.sendInvite);
};
